export default __webpack_public_path__ + "static/media/old-ojo-terminal.ff926f07.png";